module.exports = __webpack_public_path__ + "static/img/404.07e42a1b.png";